import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {

  constructor(private spinner: NgxSpinnerService, private admin: AdminService) { }

  ngOnInit() {
    this.admin.loaderState.subscribe(data => {
      if (data) {
      this.spinner.show();
      } else {
      this.spinner.hide();
      }
    });
  }

}
